import { useQuery } from '@tanstack/react-query';

import { getRetryDelay, shouldRetryRequest } from '@/shared/lib/query/retryConfig';

import { projectApi } from '@/entities/project/api/projectApi';
import type { ProjectDetail } from '@/entities/project/domain/types';

export const PROJECT_QUERY_KEY = 'project';

export const useProject = (projectId: number, enabled = true) => {
  return useQuery<ProjectDetail>({
    queryKey: [PROJECT_QUERY_KEY, projectId],
    queryFn: () => projectApi.getById(projectId),
    enabled,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    retry: shouldRetryRequest,
    retryDelay: getRetryDelay,
  });
};
